module.exports = __webpack_public_path__ + "img/inspection.ce940ad.webp";